/** The SDICS Field app for chiefs and registration officers (Flutter build,
 *  mobile-flutter/). Each release is copied to /var/www/sdics/downloads/ on
 *  the server; bump this when publishing a new one. */
export const FIELD_APK = { href: '/downloads/SDICS-Field-v2.4.6.apk', version: '2.4.6' };

/** The SDICS Dashboard app for administrators (Flutter build, mobile-dashboard/):
 *  this dashboard as a native Android app. Published the same way. */
export const DASHBOARD_APK = { href: '/downloads/SDICS-Dashboard-v1.7.0.apk', version: '1.7.0' };

/** Permanent links: symlinks in /var/www/sdics/downloads/ that are re-pointed at
 *  each release. Printed QR codes use these, so never rename them. */
export const FIELD_APK_LATEST = 'https://sdics.tech/downloads/SDICS-Field.apk';
export const DASHBOARD_APK_LATEST = 'https://sdics.tech/downloads/SDICS-Dashboard.apk';
